const results = document.querySelector('results-list[data-size-collection="true"]');
if (results) {
  const url = new URL(window.location.href);
  const previous = url.search;
  for (const key of ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte']) {
    url.searchParams.delete(key);
  }
  if (['price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by') || results.dataset.sizeCurrentSort || '')) {
    url.searchParams.set('sort_by', results.dataset.sizeDefaultSort || 'manual');
  }
  if (previous !== url.search) {
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  }
}
